import { Box, TextField } from '@mui/material';
import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { IClient } from '../../../../shared/interfaces/clients/IClient';

interface IProps {
  selectedClient: IClient | undefined;
  setSelectedClient: React.Dispatch<SetStateAction<IClient | undefined>>;
}
const ClientFormModalBody = ({ selectedClient, setSelectedClient }: IProps) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ marginTop: '30px', marginBottom: '30px', width: '100%' }}>
      <TextField
        value={selectedClient?.name}
        onChange={(e) => {
          setSelectedClient(
            (prev) => ({ ...prev, name: e?.target?.value }) as IClient,
          );
        }}
        label={t('general.name')}
        sx={{ width: '100%' }}
      />
    </Box>
  );
};

export default ClientFormModalBody;
